export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/ebay.076fc4a.svg";